<template>
  <div
    class="as-line-up-colunm"
    :class="{
      'as-line-up-colunm-sm': screenWidth < 370,
    }"
  >
    <div class="as-line-up-colunm-item">
      <div
        v-for="(player, key) in startingPlayers.home"
        :key="key"
        class="as-line-up-item as-line-up-item-home"
        :class="{
          'as-line-up-item-last':
            `${key}` === `${startingPlayers.home.length - 1}`,
        }"
      >
        <PlayerItemTab
          :player="player"
          :isInjuredSuspended="isInjuredSuspended"
          :isSubstituted="isSubstituted"
        />
      </div>
    </div>
    <div class="as-line-up-colunm-item">
      <div
        v-for="(player, key) in startingPlayers.away"
        :key="key"
        class="as-line-up-item as-line-up-item-away"
        :class="{
          'as-line-up-item-last':
            `${key}` === `${startingPlayers.home.length - 1}`,
        }"
      >
        <PlayerItemTab
          :player="player"
          flex="end"
          :isInjuredSuspended="isInjuredSuspended"
          :isSubstituted="isSubstituted"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import type { ILineups, IMatch, IStartingPlayers } from "~src/interfaces";
import PlayerItemTab from "~src/components/lineups/PlayerItemTab.vue";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
const matchDetailStore = useMatchDetailStore();

interface IProps {
  lineups: ILineups;
  match: IMatch;
  startingPlayers: IStartingPlayers;
  isInjuredSuspended: boolean;
  isSubstituted: boolean;
}

withDefaults(defineProps<IProps>(), {
  isInjuredSuspended: false,
  isSubstituted: false,
});

const screenWidth = computed(() => matchDetailStore.getScreenWidth);
</script>

<script lang="ts">
export default {};
</script>
